
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/aboutUs",
      function () {
        return require("private-next-pages/footerItems/aboutUs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/aboutUs"])
      });
    }
  